import React, { FC } from 'react';
import { LANGUAGE } from '../../../../constants/main';
import useTranslations, { TranslateFunction } from '@hooks/useTranslations';
import { LocaleString, useDateUtils } from '@utils/Date.utils';

interface OrderNumberComponentProps {
    orderNumber: string;
    orderDate: Date;
}

export const OrderNumberComponent: FC<OrderNumberComponentProps> = ({ orderNumber, orderDate }) => {
    const { formatDate } = useDateUtils();
    const { t } = useTranslations();
    return (
        <div className="deal-content__order-data">
            <span className="deal-content__order-data--order-number">
                {t('myaccount.myOrders.orderNo')}: {orderNumber}
            </span>
            <span className="deal-content__order-data--date">
                {t('myaccount.myOrders.orderAt')}:{' '}
                {formatDate(orderDate, LANGUAGE as LocaleString, t('dateformat.myOrder'))}
            </span>
        </div>
    );
};
